import isEmpty from 'lodash/isEmpty';
import { ONLINE_VIEW, VIEW_ONLINE, columnTypes as softwareDocumentsModalColumnsTypes, } from "@pes-ui/utils";
export const softwareDocumentsColumns = (productSoftwareInfo) => {
  if (!productSoftwareInfo) {
    return [];
  }
  return [
    {
      label: productSoftwareInfo.availableVersionsLabel,
      type: softwareDocumentsModalColumnsTypes.VERSIONS,
    },
    {
      label: productSoftwareInfo.operatingSystemsLabel,
      type: softwareDocumentsModalColumnsTypes.OS,
    },
    {
      label: productSoftwareInfo.languageLabel,
      type: softwareDocumentsModalColumnsTypes.LANGUAGE,
    },
    {
      label: productSoftwareInfo.formatLabel,
      type: softwareDocumentsModalColumnsTypes.FORMAT,
    },
    {
      label: productSoftwareInfo.sizeLabel,
      type: softwareDocumentsModalColumnsTypes.SIZE,
    },
    {
      label: productSoftwareInfo.dateLabel,
      type: softwareDocumentsModalColumnsTypes.DATE,
    },
  ];
};
export const softwareDocumentsData = (productSoftwareInfo) => {
  if (isEmpty(productSoftwareInfo)) {
    return [];
  }
  return productSoftwareInfo.softwareDocuments.reduce((result, document) => {
    const { date, format, language, link, os, size, title, version, documentReference, documentName, documentType, downloadAll, files, } = document;
    return [
      ...result,
      {
        link,
        fileType: format,
        documentReference,
        documentName,
        documentType,
        downloadAll,
        files,
        cells: [
          {
            text: `${title !== null && title !== void 0 ? title : ''}${version ? ` (${productSoftwareInfo.versionLabel} ${version})` : ''}`,
            type: softwareDocumentsModalColumnsTypes.VERSIONS,
          },
          {
            text: os,
            mobileLabel: productSoftwareInfo.operatingSystemsLabel,
            type: softwareDocumentsModalColumnsTypes.OS,
          },
          {
            text: language,
            mobileLabel: productSoftwareInfo.languageLabel,
            type: softwareDocumentsModalColumnsTypes.LANGUAGE,
          },
          {
            text: format,
            type: softwareDocumentsModalColumnsTypes.FORMAT,
          },
          {
            text: size,
            type: softwareDocumentsModalColumnsTypes.SIZE,
          },
          {
            text: date,
            type: softwareDocumentsModalColumnsTypes.DATE,
          },
        ],
      },
    ];
  }, []);
};
export const additionalInfoData = (productSoftwareInfo) => {
  const doc = productSoftwareInfo.softwareDocuments[0];
  const { availableVersionsLabel, operatingSystemsLabel, languageLabel, formatLabel, sizeLabel, dateLabel, versionLabel, } = productSoftwareInfo;
  return {
    title: doc.title,
    version: doc.version,
    labels: {
      availableVersionsLabel,
      operatingSystemsLabel,
      languageLabel,
      formatLabel,
      sizeLabel,
      dateLabel,
      versionLabel,
    },
    os: doc.os,
    format: doc.format,
    size: doc.size,
    date: doc.date,
    language: doc.language,
  };
};
export const isViewOnline = (documentName) => {
  return documentName === VIEW_ONLINE || documentName === ONLINE_VIEW;
};
export const getDownloadButtonLabel = (softwareDocuments, button, downloadLabel) => {
  var _a;
  if (isEmpty(button)) {
    return null;
  }
  const { onlineLabel, areaLabel } = button.labels;
  if ((softwareDocuments === null || softwareDocuments === void 0 ? void 0 : softwareDocuments.length) > 1) {
    return areaLabel;
  }
  if ((softwareDocuments === null || softwareDocuments === void 0 ? void 0 : softwareDocuments.length) === 1) {
    const { documentName, files, downloadAll } = softwareDocuments[0];
    const hasOnlineView = isViewOnline(documentName);
    const hasDownloadLink = downloadAll || (files && ((_a = files[0]) === null || _a === void 0 ? void 0 : _a.link));
    if (hasOnlineView && hasDownloadLink) {
      return areaLabel;
    }
    return hasOnlineView ? onlineLabel : downloadLabel;
  }
};
export const getDownloadButtonIcon = (softwareDocuments) => {
  var _a;
  if ((softwareDocuments === null || softwareDocuments === void 0 ? void 0 : softwareDocuments.length) > 1) {
    return "square-behind-another";
  }
  if ((softwareDocuments === null || softwareDocuments === void 0 ? void 0 : softwareDocuments.length) === 1) {
    const { documentName, files, downloadAll } = softwareDocuments[0];
    const hasOnlineView = isViewOnline(documentName);
    const hasDownloadLink = downloadAll || (files && ((_a = files[0]) === null || _a === void 0 ? void 0 : _a.link));
    if (hasOnlineView && hasDownloadLink) {
      return "square-behind-another";
    }
    return hasOnlineView ? "arrow-top-right-on-square" : "arrow-down-tray";
  }
};
